import React from "react"
import { Grid } from "@material-ui/core"
import { Text, themeColors } from "letalkui"

import {
	AccessTime as ClockIcon,
	PlayCircleOutline as ActuationIcon,
	Group as GroupIcon
} from "@material-ui/icons"

import useStyles from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListDetails/styles"

import { fullDatetime } from "@/utils/time"

import { RoleFormattedForList } from "@/services/RoleService"

type RoleListDetailsProps = {
	role: RoleFormattedForList
}

const RoleListDetails: React.FC<RoleListDetailsProps> = (props) => {
	const { role } = props

	const classes = useStyles()

	const lastEditDate = fullDatetime(new Date(role?.updatedAt))
	const lastUpdatedUserName = role.lastUpdatedUserName

	return (
		<Grid container alignItems="center">
			<Grid item sm={4} md={4}>
				<Grid container alignItems="center" justifyContent="center" style={{ gap: "4px" }}>
					<GroupIcon fontSize="medium" style={{ color: themeColors.getPrimaryColor() }}/>
					<Text.Body type="small1" fontWeight="bold">{role.usersInRoleQuantity}</Text.Body>
				</Grid>
			</Grid>
			<Grid item sm={6} md={8}>
				<Grid container direction="column" spacing={1}>
					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start">
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ClockIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item>
								<Text.Body type="small2" sx={{ opacity: "0.5" }} color={themeColors.colors.system.gray[700]}>Última alteração: {lastEditDate}</Text.Body>
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start" wrap="nowrap">
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ActuationIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item className={classes.lastUpdatedUserContainer}>
								<Text.Body
									type="small2"
									className={classes.lastUpdatedUserName}
									sx={{ opacity: "0.5" }}
									color={themeColors.colors.system.gray[700]}
									title={`Último usuário que editou: ${lastUpdatedUserName}`}
								>
									Último usuário que editou: {lastUpdatedUserName}
								</Text.Body>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default RoleListDetails
